import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { Provider } from '@/services/providerService'

export const useViewingProviderStore = defineStore('viewingProvider', () => {
  // State
  const viewingProvider = ref<Provider | null>(null)
  const isViewingAsProvider = computed(() => viewingProvider.value !== null)

  // Actions
  const startViewingAsProvider = (provider: Provider) => {
    viewingProvider.value = provider
    console.log('Started viewing as provider:', provider.id, provider.businessName, 'code:', provider.code)
  }

  const stopViewingAsProvider = () => {
    console.log('Stopped viewing as provider')
    viewingProvider.value = null
  }

  const getViewingProviderId = computed(() => {
    return viewingProvider.value?.id || null
  })

  // Reset store (called on logout)
  const $reset = () => {
    viewingProvider.value = null
  }

  return {
    // State
    viewingProvider,
    isViewingAsProvider,
    getViewingProviderId,

    // Actions
    startViewingAsProvider,
    stopViewingAsProvider,

    // Store Management
    $reset
  }
})
